export const GATSBY_PRICE_FETCHER_URL = process.env.GATSBY_PRICE_FETCHER_URL
export const GATSBY_SENDGRID_API_KEY = process.env.GATSBY_SENDGRID_API_KEY
export const GATSBY_EMAILJS_PUBLICK_KEY = process.env.GATSBY_EMAILJS_PUBLICK_KEY
export const GATSBY_EMAILJS_TEMPLATE_ID = process.env.GATSBY_EMAILJS_TEMPLATE_ID
export const GATSBY_EMAILJS_SERVICE_ID = process.env.GATSBY_EMAILJS_SERVICE_ID
export const GATSBY_SENDGRID_TOKEN = process.env.GATSBY_SENDGRID_TOKEN
export const GATSBY_FETCH_APY_URL = process.env.GATSBY_FETCH_APY_URL
export const GATSBY_SENDGRID_URL = process.env.GATSBY_SENDGRID_URL
export const GATSBY_GOOGLE_TRACK_ID = process.env.GATSBY_GOOGLE_TRACK_ID
